import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActionState } from 'src/app/enums/action-state.enum';
import { BadgeRepo } from 'src/app/repositories/badge-repo';
import { DataAfterCloseBadgesModal } from './models/dataAfterCloseBadgesModal';

@Component({
    selector: 'app-modal-badges',
    templateUrl: './modal-badges.component.html',
    styleUrls: ['./modal-badges.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalBadgesComponent implements OnInit {

  // downloadFile
  backendResponseDownloadedFile: any = null;
  // uploadFile
  backendResponseUploadedFile: any = null;

  constructor(
    private badgeRepo: BadgeRepo,
    @Inject(MAT_DIALOG_DATA) public data: DataAfterCloseBadgesModal) {
  }

  ngOnInit(): void {
    this.data = new DataAfterCloseBadgesModal();
  }

  onUserWantsDownloadEvent(event: boolean): void {
    if (event) {
      this.downloadFile();
    }
  }

  onUserWantsUploadEvent(file: any): void {
    if (file) {
      this.uploadFile(file);
    }
  }

  downloadFile(): void {
    this.badgeRepo.exportBadgeDefinition().toPromise()
    .then((response) => {
      this.backendResponseDownloadedFile = response;
    })
    .catch((err) => {
      this.backendResponseDownloadedFile = err;
    });
  }

  uploadFile(file: any): void {
    this.data.uploadFileState = ActionState.LOADING;
    this.badgeRepo.importBadgeDefinition(file).toPromise()
    .then((response) => {
      this.backendResponseUploadedFile = response;
      this.data.uploadFileState = ActionState.SUCCESS;
    })
    .catch((err) => {
      this.backendResponseUploadedFile = err;
      this.data.uploadFileState = ActionState.FAILED;
    });
  }
}
